import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { isClickHit } from '../../store/apiWrapper';

import "./moreButton.scss";

class FixedRightTableTools extends Component {
    state = {
        expanded: false
    }

    static propTypes = {
        content: PropTypes.object.isRequired,
        contentWidth: PropTypes.number.isRequired,
        id: PropTypes.string.isRequired,
        style: PropTypes.object,
        menuStyle: PropTypes.object,
        buttons: PropTypes.array.isRequired
    }

    static defaultProps = {
        contentWidth: 100,
        style: undefined,
        menuStyle: undefined,
        buttonStyle: null,
        buttons: []
    }

    render() {
        const btnStyle = this.props.buttonStyle;
        return (
            <div className="more-button" style={this.props.style}>
                <div style={ btnStyle === null ? undefined : btnStyle} className="btn-wrap" onClick={() => this.setState({ expanded: !this.state.expanded })}>
                    {this.props.content}
                </div>
                {this.state.expanded &&
                    <div className="more-button-items" id={this.props.id} style={this.props.menuStyle} onMouseOut={(e) => this.handleMouseOut(e)}>
                        <div className="items">
                            {this.props.buttons.map(b => <div className={`m-btn ${this.props.buttonClassName}`.trim()} style={{ padding: "0.3em 0.2em" }}
                                onClick={(e) => this.toolClicked(b, e)}
                            >
                                {b.item}
                            </div>)}
                        </div>
                    </div>
                }
            </div>
        )
    }

    toolClicked = (btn, evt) => {
        evt.stopPropagation();
        btn.action();
        this.setState({ expanded: false });
    }

    handleMouseOut = (e) => {
        if (!isClickHit(document.querySelector(`#${this.props.id}`), e)) {
            this.setState({ expanded: false });
        }
    }
}

export default FixedRightTableTools;
